import { render, staticRenderFns } from "./g-searchinput.vue?vue&type=template&id=35cff80d&scoped=true"
import script from "./g-searchinput.vue?vue&type=script&lang=js"
export * from "./g-searchinput.vue?vue&type=script&lang=js"
import style0 from "./g-searchinput.vue?vue&type=style&index=0&id=35cff80d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cff80d",
  null
  
)

export default component.exports